export default function detectEditMode() {
    return document.documentElement.classList.contains('ccm-edit-mode');
}


// WEBPACK FOOTER //
// ./scripts/utils/detect-edit-mode.js